export const calcDimensions = (dimensions) => ({
  ...dimensions,
  boundedWidth:
    dimensions.width - dimensions.margin.left - dimensions.margin.right,
  boundedHeight:
    dimensions.height - dimensions.margin.top - dimensions.margin.bottom,
});
